import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeleteScrapRuleProps {
  onSuccess: () => void
  onError: (error: any) => void
}

export const useDeleteScrapRule = ({ onSuccess, onError }: UseDeleteScrapRuleProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deleteScrapRule'],
    mutationFn: async (scrapRuleId?: string) => {
      return privateAxios.delete(`/maintenance/scrap_rules/${scrapRuleId}`)
    },
    onSuccess,
    onError,
  })
}
